import { createSlice } from "@reduxjs/toolkit";
import flashSaleApi from "./api";
import { toast } from "react-toastify";

const initialState = {
  times: [],
  isLoading: false,
  currentSlotData: null,
  isLoadingSlot: false,
  dishes: [],
  isLoadingDishes: false,
  isProcessing: false,
};

export const flashSaleSlice = createSlice({
  name: "flashSale",
  initialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setTimes: (state, action) => {
      state.times = action.payload;
    },
    setIsLoadingSlot: (state, action) => {
      state.isLoadingSlot = action.payload;
    },
    setCurrentSlotData: (state, action) => {
      state.currentSlotData = action.payload;
    },
    setIsLoadingDishes: (state, action) => {
      state.isLoadingDishes = action.payload;
    },
    setIsProcessing: (state, action) => {
      state.isProcessing = action.payload;
    },
    setDishes: (state, action) => {
      state.dishes = action.payload;
    },
    addDish: (state, action) => {
      state.dishes.push(action.payload);
    },
    updateDish: (state, action) => {
      const index = state.dishes.findIndex(
        (dish) => dish._id === action.payload._id
      );
      if (index !== -1) {
        state.dishes[index] = action.payload;
      }
    },
    removeDish: (state, action) => {
      state.dishes = state.dishes.filter((dish) => dish._id !== action.payload);
    },
  },
});

export const {
  setIsLoading,
  setTimes,
  setIsLoadingSlot,
  setCurrentSlotData,
  setIsLoadingDishes,
  setIsProcessing,
  setDishes,
  addDish,
  updateDish,
  removeDish,
} = flashSaleSlice.actions;

export const fetchTimes = (params) => {
  return async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const data = await flashSaleApi.getTimes(params);
      if (data.error) {
        toast.error(data.error.msg);
      } else {
        dispatch(setTimes(data.data));
      }
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setIsLoading(false));
    }
  };
};

export const fetchByCode = (code) => {
  return async (dispatch) => {
    dispatch(setIsLoadingSlot(true));
    try {
      const data = await flashSaleApi.getByCode(code);
      if (data.error) {
        toast.error(data.error.msg);
      }
      if (data.data && data.data.dishes) {
        dispatch(setDishes(data.data.dishes));
      }
      dispatch(setCurrentSlotData(data.data));
    } catch (err) {
      console.log(err);
      dispatch(setCurrentSlotData(null));
      dispatch(setDishes([]));
    } finally {
      dispatch(setIsLoadingSlot(false));
    }
  };
};

export const updateFlashSale = (id, dishData) => {
  return async (dispatch) => {
    try {
      const data = await flashSaleApi.update(id, dishData);
      if (data.error) {
        toast.error(data.error.msg);
      } else {
        dispatch(setCurrentSlotData(data.data));
        toast.success("Cập nhật flash sale thành công!");
      }
    } catch (err) {
      console.log(err);
      toast.error("Có lỗi xảy ra khi cập nhật flash sale");
    }
  };
};

export const createDish = (flashSaleId, dishData, currentCode) => {
  return async (dispatch) => {
    try {
      dispatch(setIsProcessing(true));
      const data = await flashSaleApi.createDish(flashSaleId, dishData);
      if (data.error) {
        throw new Error(data.error.msg);
      } else {
        toast.success("Thêm món ăn vào flash sale thành công!");
        // Refresh flash sale data
        if (currentCode) {
          await dispatch(fetchByCode(currentCode));
        }
        return data.data; // Return success data
      }
    } catch (err) {
      console.log(err);
      toast.error("Có lỗi xảy ra: " + err.message);
      throw err;
    } finally {
      dispatch(setIsProcessing(false));
    }
  };
};

export const editDish = (flashSaleId, dishId, dishData, currentCode) => {
  return async (dispatch) => {
    try {
      dispatch(setIsProcessing(true));
      const data = await flashSaleApi.updateDish(flashSaleId, dishId, dishData);
      if (data.error) {
        throw new Error(data.error.msg);
      } else {
        toast.success("Cập nhật món ăn thành công!");
        // Refresh flash sale data
        if (currentCode) {
          await dispatch(fetchByCode(currentCode));
        }
        return data.data; // Return success data
      }
    } catch (err) {
      console.log(err);
      toast.error("Có lỗi xảy ra: " + err.message);
      throw err;
    } finally {
      dispatch(setIsProcessing(false));
    }
  };
};

export const deleteDish = (flashSaleId, dishId, currentCode) => {
  return async (dispatch) => {
    try {
      dispatch(setIsProcessing(true));
      const data = await flashSaleApi.deleteDish(flashSaleId, dishId);
      if (data.error) {
        throw new Error(data.error.msg);
      } else {
        toast.success("Xóa món ăn thành công!");
        // Refresh flash sale data
        if (currentCode) {
          await dispatch(fetchByCode(currentCode));
        }
        return true; // Return success
      }
    } catch (err) {
      console.log(err);
      toast.error("Có lỗi xảy ra: " + err.message);
      throw err;
    } finally {
      dispatch(setIsProcessing(false));
    }
  };
};
export default flashSaleSlice.reducer;
